import { jsx } from "panel";
import { TooltipEl } from "common/components/tooltip";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { hasSlot } from "common/util/dom";
import { queryBuilderUtils } from "common/query-builder/query-builder/util";
export function template() {
  const { isOpen } = this.state;
  const canClickRow = this.attr(`enable-row-click`);
  const hiddenTitle = !this.attr(`header-title`);
  const hasActions = hasSlot(this, `actions`) || !this.attr(`non-collapsible`);
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-section",
    class: {
      "is-closed": !isOpen,
      inline: this.attr(`theme`) === this.helpers.CollapsibleTheme.INLINE
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-section-title-container",
    class: {
      "is-clickable": canClickRow && !this.attr(`non-collapsible`),
      "is-non-collapsible": this.attr(`non-collapsible`),
      "has-new-ui": queryBuilderUtils.isCoreReport(),
      hidden: hiddenTitle
    },
    on: {
      click: canClickRow ? this.helpers.toggleOpen : null
    }
  }, this.helpers.hasSlot(this, `title`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-section-title.is-uppercase"
  }, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `title` }
  })) : !hiddenTitle ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-section-title",
    attrs: {
      elref: `sectionTitle`
    },
    class: {
      "is-clickable": !this.attr(`non-collapsible`),
      "is-uppercase": !this.attr(`header-title-lowercase`)
    },
    on: {
      click: !canClickRow && !this.attr(`non-collapsible`) ? this.helpers.toggleOpen : null
    }
  }, this.attr(`header-title`), this.attr(`tooltip-text`) ? /* @__PURE__ */ jsx(TooltipEl, null, this.attr(`tooltip-text`)) : null) : null, hasActions && /* @__PURE__ */ jsx("div", {
    sel: ".mp-section-actions"
  }, hasSlot(this, `actions`) && /* @__PURE__ */ jsx("slot", {
    attrs: { name: `actions` }
  }), !this.attr(`non-collapsible`) && /* @__PURE__ */ jsx(ButtonEl, {
    class: {
      hidden: this.attr(`hide-caret`)
    },
    attrs: {
      icon: isOpen ? `caret-up` : `caret-down`,
      theme: ButtonTheme.Tertiary
    },
    on: {
      click: !canClickRow ? this.helpers.toggleOpen : null
    }
  }))), /* @__PURE__ */ jsx("div", {
    sel: ".mp-section-body"
  }, /* @__PURE__ */ jsx("slot", null)));
}
